"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maintainTabFocus = void 0;
var tab_focus_1 = __importDefault(require("ally.js/maintain/tab-focus"));
var maintainTabFocus = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return tab_focus_1.default.apply(void 0, args);
};
exports.maintainTabFocus = maintainTabFocus;
//# sourceMappingURL=maintain-tab-focus.js.map